// Costo de envío único a cualquier punto de Uruguay (Carrito.jsx lo suma
// al total, y el JSON-LD de producto en Customize.jsx lo declara en
// shippingDetails para Google Merchant Listings) -- un solo valor
// compartido para que no puedan quedar desincronizados.
export const SHIPPING_COST = 300;
